'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of play button
 */ const PlayButton = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 105 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52.3711",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3481_553)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("ellipse", {
                        cx: "56.0898",
                        cy: "52.8494",
                        rx: "20",
                        ry: "21.1228",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M85.9225 45.0856C85.4716 42.8814 84.7985 40.7134 83.9221 38.6414C83.0622 36.6075 81.9974 34.6463 80.758 32.8115C79.5306 30.9948 78.1214 29.2869 76.5688 27.7343C75.0165 26.1821 73.3082 24.7724 71.4915 23.545C69.6571 22.3057 67.6955 21.2409 65.6616 20.3806C63.5897 19.5041 61.4216 18.831 59.2174 18.3801C56.9571 17.9181 54.6311 17.6836 52.3039 17.6836C49.9767 17.6836 47.6506 17.9181 45.3903 18.3805C43.1861 18.8314 41.0181 19.5045 38.9461 20.381C36.9122 21.2413 34.951 22.3057 33.1166 23.5454C31.2999 24.7728 29.5916 26.1821 28.0394 27.7347C26.4871 29.2869 25.0775 30.9952 23.8501 32.8119C22.6108 34.6463 21.546 36.6079 20.6857 38.6418C19.8096 40.7138 19.1365 42.8818 18.6852 45.086C18.2228 47.3463 17.9883 49.6724 17.9883 51.9992C17.9883 54.326 18.2228 56.6524 18.6856 58.9127C19.1365 61.1169 19.8096 63.285 20.686 65.3569C21.5463 67.3908 22.6112 69.3521 23.8505 71.1868C25.0779 73.0035 26.4871 74.7115 28.0397 76.2641C29.592 77.8163 31.3003 79.2259 33.117 80.4533C34.9514 81.6927 36.913 82.7575 38.9465 83.6178C41.0185 84.4942 43.1865 85.1673 45.3907 85.6182C47.651 86.081 49.9774 86.3155 52.3043 86.3155C54.6311 86.3155 56.9575 86.081 59.2178 85.6182C61.422 85.1673 63.59 84.4942 65.662 83.6178C67.6959 82.7575 69.6571 81.693 71.4919 80.4533C73.3086 79.2259 75.0169 77.8167 76.5691 76.2641C78.1214 74.7118 79.531 73.0035 80.7584 71.1868C81.9977 69.3524 83.0625 67.3908 83.9225 65.3569C84.7989 63.285 85.472 61.1169 85.9229 58.9127C86.3857 56.652 86.6202 54.326 86.6202 51.9992C86.6202 49.6724 86.3857 47.3459 85.9229 45.0856H85.9225ZM68.7215 53.671C68.4274 54.2134 67.9915 54.6658 67.4606 54.9795L47.5095 66.7596C46.9956 67.0629 46.4155 67.2224 45.8285 67.2224C45.8093 67.2224 45.7901 67.2224 45.7709 67.2224C45.2023 67.2121 44.64 67.0522 44.1445 66.7596C43.6493 66.4671 43.2326 66.0489 42.9397 65.5507C42.6272 65.0186 42.4623 64.4063 42.4623 63.7793V40.2194C42.4623 39.5925 42.6276 38.9801 42.9397 38.4481C43.2326 37.9495 43.6493 37.5317 44.1445 37.2391C44.64 36.947 45.2023 36.7871 45.7705 36.7767C46.3771 36.7655 46.9783 36.9258 47.5092 37.2391L67.4602 49.0193C67.9911 49.3329 68.4274 49.7854 68.7211 50.3278C68.9967 50.8363 69.1424 51.4145 69.1424 51.9996C69.1424 52.5846 68.9967 53.1624 68.7211 53.6713L68.7215 53.671Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3481_553",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "68.6316",
                        height: "68.6316",
                        fill: "white",
                        transform: "translate(17.9883 17.6855)"
                    })
                })
            })
        ]
    });
};

exports.PlayButton = PlayButton;
//# sourceMappingURL=PlayButton.cjs.map
